import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import { getEmpadronamientoHistorialPrevio } from "../../../../actions/empadronamiento/Empadronamiento";
import { EmpadronamientoHistorialItem } from "../../Ingreso/EmpadronamientoHistorialItem";

const TabsEmpadronamiento = (props) => {
  const dispatch = useDispatch();

  const { solicitudesHistorial } = useSelector((state) => state.empadronamiento);

  useEffect(() => {
    if (props.afiliado?.id_afiliado)
      dispatch(getEmpadronamientoHistorialPrevio(props.afiliado?.id_afiliado));
  }, [dispatch]);

  return (
    <>
      {Array.isArray(solicitudesHistorial) && solicitudesHistorial?.length > 0 ? (
        <Table>
          <TableHead>
            <TableRow>
              <TableCell style={{ width: "8%" }}>Estado</TableCell>
              <TableCell style={{ width: "6%" }}>Solicitud N°</TableCell>
              <TableCell style={{ width: "10%" }}>Inicio</TableCell>
              <TableCell style={{ width: "10%" }}>Fin</TableCell>
              <TableCell style={{ width: "20%" }}>Programa</TableCell>
              <TableCell style={{ width: "12%" }}>Usuario</TableCell>
              <TableCell style={{ width: "5%" }}>Diagnósticos</TableCell>
              <TableCell style={{ width: "5%" }}>Medicamentos</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {solicitudesHistorial.map((solicitud, index) => {
              return (
                <EmpadronamientoHistorialItem
                  key={solicitud?.idSolicitud.toString()}
                  solicitud={solicitud}
                  ocultarEstado={false}
                />
              );
            })}
          </TableBody>
        </Table>
      ) : (
        <Typography style={{ fontSize: "1.1rem", fontStyle: "italic" }}>
          No hay Empadronamientos
        </Typography>
      )}
    </>
  );
};

export default TabsEmpadronamiento;
